import ServiceCategoryPage from "../components/ServiceCategoryPage";
import yogaInstructorService from "../data/services/yogaInstructorService";

function YogaInstructor() {
  return <ServiceCategoryPage service={yogaInstructorService} />;
}

export default YogaInstructor;